import React from "react";
import { t } from "ttag";

import styles from "./index.module.scss";

export const CancelError = (): React.JSX.Element => {
    return (
        <p className={styles.root}>
            {t`You are outside of the cancellation window. This order can no longer be cancelled or modified.`}
        </p>
    );
};
